import React from 'react';
import { ArrowRight } from 'lucide-react';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import ErrorPage from '../../Common/ErrorPages';
import useMenuItemNavigation from '../../../../hooks/useMenuItemNavigation';

const CLSSENotFound = () => {
  const onMenuItemClick = useMenuItemNavigation({ brandSlug: 'clsse', feSlug: 'cls-se' });

  return (
    <ErrorPage
      Header={Header}
      Footer={Footer}
      brandAttr="CLS"
      code="404"
      title="Sidan hittades inte"
      description="Sidan du letar efter finns inte eller har flyttats."
      primaryCta={{
        label: 'Till Skolmerch',
        onClick: () => onMenuItemClick('menu_1'),
        icon: <ArrowRight size={20} />,
      }}
      secondaryCta={{ label: 'Gå till FAQ', to: '/clothing/cls-se/faq' }}
    />
  );
};

export default CLSSENotFound;
